var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderSelectedIconSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 1.99994H8.31466C8.21156 2.00063 8.10966 1.97781 8.01666 1.93328L5.91266 0.877282C5.63491 0.73897 5.32894 0.666876 5.01866 0.666626H3.33331C1.49331 0.668813 0.00221875 2.15991 0 3.99994V4.66059L15.9087 4.58659C15.5613 3.07519 14.2175 2.00303 12.6667 1.99994ZM0 5.99366V11.9997C0.00221875 13.8397 1.49331 15.3308 3.33334 15.333H12.6667C14.5067 15.3308 15.9978 13.8397 16 11.9997V5.91966L0 5.99366ZM4.64582 10.1153L6.54235 12.0118L11.3587 7.19998L12 7.84125L6.54235 13.2989L4 10.7565L4.64582 10.1153Z",
    fill: "#DB5327"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSelectedIconSolid);
export default __webpack_public_path__ + "static/media/FolderSelectedIconSolid.3044e1d705a99f0254295ca47922ce7f.svg";
export { ForwardRef as ReactComponent };